import { useNavigate } from '../nav'
import { GitBranch } from 'lucide-react'
import StatusBadge from '../StatusBadge'
import type { DuplicateDetection } from '../../data/projectTypes'
import './DuplicatesDetected.css'

/**
 * The "Duplicates Detected" section: findings that were filed but matched an existing bug. Shown on
 * a run page and on a container task's page (the duplicates that specific task filed).
 * Renders nothing when there are no duplicates.
 */
export default function DuplicatesDetected({ duplicates, projectId }: {
  duplicates: DuplicateDetection[]
  projectId: string
}) {
  const navigate = useNavigate()
  if (duplicates.length === 0) return null

  return (
    <section className="duplicates-detected" data-testid="duplicates-detected">
      <h2 className="duplicates-detected__header">
        <GitBranch size={14} aria-hidden="true" /> Duplicates Detected ({duplicates.length})
      </h2>
      <ul className="duplicates-detected__list">
        {duplicates.map(dup => (
          <li key={dup.id} className="duplicates-detected__item">
            <div className="duplicates-detected__new">
              <span className="duplicates-detected__label">Filed:</span>
              <span className="duplicates-detected__title">{dup.new_title}</span>
            </div>
            <div className="duplicates-detected__existing">
              <span className="duplicates-detected__label">Matched:</span>
              <button
                className="duplicates-detected__link"
                onClick={() => navigate(`/projects/${projectId}/bugs/${dup.existing_bug_id}`)}
                data-analytics-event="bug-duplicate-open"
              >
                <StatusBadge status={dup.existing_bug_severity} variant="severity" />
                {dup.existing_bug_title}
                <StatusBadge status={dup.existing_bug_status} variant="bug" />
              </button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
